const buildStyles = ({ font, fontSize, fontWeight, italic, underline, color }) => {
  return {
    'fontFamily': `"${font}"`,
    'fontSize': `${fontSize}px`,
    fontWeight,
    'fontStyle': italic ? 'italic' : undefined,
    'textDecoration': underline ? 'underline' : undefined,
    'lineHeight': `${fontSize}px`,
    color,
  }
}

export default buildStyles
